import { Traveler } from './../../../shared/models/traveler.model';
import { TravelersService } from './../../services/travelers.service';
import { FilterCallback } from './../../../shared/base-reporting/models/filter-callback.interface';
import { RowActionCallback } from './../../../shared/base-reporting/models/row-action-callback.interface';
import { FilterItem } from './../../../shared/base-reporting/models/filter-item.interface';
import { Router } from '@angular/router';
import { RowAction } from './../../../shared/base-reporting/models/row-actions.interface';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import moment from 'moment';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})
export class ListComponent implements OnInit {

  traveler = new Traveler();
  viewFlag = false;
  @ViewChild('viewTraveler', { static: true }) viewTraveler: ElementRef;
  private Data = [] as Array<TableViewItem>;
  tableColumns = [
    'email',
    'firstName',
    'lastName',
    'status'
  ];

  get data(): Array<TableViewItem> {
    return this.Data
      .filter(row => {
        if (this.currentFilterObject.email) {
          return row.email.toLowerCase().includes(this.currentFilterObject.email.toLowerCase());
        }
        return true;
      })
      .filter(row => {
        if (this.currentFilterObject.firstName) {
          return this.currentFilterObject.firstName.includes(
            row.firstName
          );
        }
        return true;
      }).filter(row => {
        if (this.currentFilterObject.lastName) {
          return this.currentFilterObject.lastName.includes(
            row.lastName
          );
        }
        return true;
      }).filter(row => {
        if (this.currentFilterObject.status) {
          return this.currentFilterObject.status.includes(
            row.status
          );
        }
        return true;
      })
  }


  set data(v: Array<TableViewItem>) {
    this.Data = v;
  }

  constructor(private travelersService: TravelersService, private router: Router) { }
  currentFilterObject = {} as FilterModel;


  rowActions: Array<RowAction> = [
    {
      type: 'icon',
      slug: 'viewTraveler',
      class: 'btn',
      iconClasses: 'fa fa-eye'
    }
  ];

  ngOnInit() {
    this.fetchData();
  }
  onFilter(event: FilterCallback) {
    this.currentFilterObject = event.filter;
  }

  fetchData() {
    this.travelersService.getAllTravelers().subscribe(response => {

      this.Data = response.data.travelers.map(r => {

        if (r.email == null) {
          r.message = '-';
        }
        if (r.firstName == null) {
          r.firstName = '-';
        }
        if (r.lastName == null) {
          r.lastName = '-';
        }

        return {
          uuid: r.uuid,
          email: r.email,
          firstName: r.firstName,
          lastName: r.lastName,
          status: r.TravelerInfo != null ? r.TravelerInfo.status : '-'
        } as TableViewItem;
      });
    });
  }

  reportFilter: Array<FilterItem> = [
    {
      fieldName: 'email',
      fieldDisplayName: 'Email',
      fieldType: 'text'
    },
    {
      fieldName: 'firstName',
      fieldDisplayName: 'First Name',
      fieldType: 'text'
    },
    {
      fieldName: 'lastName',
      fieldDisplayName: 'Last Name',
      fieldType: 'text'
    },
    {
      fieldName: 'status',
      fieldDisplayName: 'Traveler Status ',
      fieldType: 'select',
      multiple: false,
      hasSelectAll: false,
      defaultValue: null,
      options: [
        { value: null, display: 'Choose Status' },
        { value: 'FIRST_TIMER', display: 'First Timer' },
        { value: 'BLOCKED', display: 'Blocked' },
        { value: 'PREMIUM', display: 'Premium' }
      ]
    }
  ];

  rowActionCB(event: RowActionCallback) {
    switch (event.action) {
      case 'viewTraveler':
        this.viewTraveler.nativeElement.click();
        this.viewFlag = true;
        this.traveler = event.on;
        break;
      default:
        console.error('this is a mistake!');
    }
  }

  fetchTable(event) {
    if (event[`flag`] === true) {
      this.fetchData();
    }
  }

  transform(input: string) {
    return input.toLowerCase().replace(/_/g, ' ')
  }
}


interface FilterModel {
  email: string;
  firstName: string;
  lastName: string;
  status: string;
}

interface TableViewItem {
  uuid: number;
  email: string;
  firstName: string;
  lastName: string;
  status: string;
}